export default [
  {
    path: '/app/popup',
    name: 'Popup',
    component: () => import('@/views/Admin/PopupImages/Index.vue'),
    meta: {
      pageTitle: 'Pop-Up Görsel',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_POPUP_LIST',
      action: 'read',
    },
  },
  {
    path: '/app/popup/add',
    name: 'PopupAdd',
    component: () => import('@/views/Admin/PopupImages/Add.vue'),
    meta: {
      pageTitle: 'Pop-Up Görsel',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/popup',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_POPUP_ADD',
      action: 'read',
    },
  },
  {
    path: '/app/popup/edit/:id',
    name: 'PopupEdit',
    component: () => import('@/views/Admin/PopupImages/Edit.vue'),
    meta: {
      pageTitle: 'Pop-Up Görsel',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/popup',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_POPUP_EDIT',
      action: 'read',
    },
  },
]
